import React, { useState, useEffect } from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import c from 'classnames';
import config from 'react-global-configuration';
import { hideNavMenu } from '../../../actions/UI';
import {
  Button,
  CoreLink,
} from '../../../components';

import './style.scss';

const NavigationMainMenuMobile = ({ path, items, setInputValue, catchEnter, setMainMenuDepth, pathArray, setPathArray }) => {
  const [interacted, setInteracted] = useState(false);
  const [hover, setHover] = useState(false);
  const [currentMenu, setCurrentMenu] = useState(items);
  const [previousMenu, setPreviousMenu] = useState(null);
  const [previousMenuLabel, setPreviousMenuLabel] = useState(null);
  const [itemsArray, setItemsArray] = useState(items);
  const dispatch = useDispatch();

  const classNames = c('NavigationMainMenuMobile', {
    'NavigationMainMenuMobile--interacted': interacted,
  });


  const addItemToPathArray = (index) => {
    setPathArray([...pathArray, index]);
  };

  useEffect(() => {
    const fetchSubTreeFromList = (array, returnSubTree = true) => {
      let currentItem = itemsArray;
      const arrayToUse = array || pathArray;

      if (pathArray.length === 0) {
        return currentItem;
      }

      for (let index = 0; index < arrayToUse.length; index++) {
        if ((index + 1) === arrayToUse.length) {
          if (returnSubTree) {
            return currentItem.get(arrayToUse[index]).get('subtree');
          } else {
            return currentItem.get(arrayToUse[index]);
          }
        } else {
          currentItem = currentItem.get(arrayToUse[index]).get('subtree');
        }
      }
    };
    setCurrentMenu(fetchSubTreeFromList());
    setMainMenuDepth(pathArray.length);
    setPreviousMenuLabel(fetchSubTreeFromList([pathArray[0]], false));
    setPreviousMenu(fetchSubTreeFromList(pathArray, false));
  }, [pathArray, setMainMenuDepth, itemsArray]);

  return (
    <div className={classNames} onMouseEnter={() => setInteracted(true)}>
      {config.get('CURRENT_DOMAIN') !== 'kp' && (
        <div className="NavigationMainMenuMobile__topBar">
          <div className="Navigation__search__inner">
            <input
              onChange={(e) => { setInputValue(e); }}
              onKeyDown={(e) => { catchEnter(e); }}
              className="Navigation__search__input"
              type="text"
              placeholder="Zoeken naar..." />
            <div className="Navigation__search__icon icon-before icon-search" />

          </div>
          {config.get('CURRENT_DOMAIN') !== 'kp' && (
            <Menu id="support-us">
              {(items) => {
                return (
                  <div className="">
                    {items.map((item) => {
                      const href = item.getIn(['link', 'url'], '');
                      const title = item.getIn(['link', 'title'], 'Untitled');
                      return (
                        <Button
                          className="Navigation__buttons--secondary Button--purple icon-after icon-heart icon-variant-4 tablet-donate"
                          href={href}
                          primary
                        >
                          {title}
                        </Button>
                      );
                    })}
                  </div>
                );
              }}
            </Menu>
          )}
        </div>
      )}
      <div className="NavigationMainMenuMobile__items">
        {pathArray.length !== 0 && (
          <>
            <div className="NavigationMainMenuMobile__back" onClick={() => { setPathArray(pathArray.splice(0, pathArray.length - 1)); }}><div className="NavigationMainMenuMobile__back__icon icon-before icon-chevron icon-variant-2" />
              Terug {previousMenuLabel && pathArray.length === 2 ? `naar ${previousMenuLabel.getIn(['link', 'title'], 'Untitled')}` : null}
            </div>
            {previousMenu && (
              <CoreLink
                className="NavigationMainMenuMobile__parent_link"
                to={previousMenu.getIn(['link', 'url'], '')}
                target={previousMenu.getIn(['link', 'options', 'attributes'], '')}
                onClick={() => { dispatch(hideNavMenu()); setHover(false); }}
              >
                {previousMenu.getIn(['link', 'title'], 'Untitled')}
              </CoreLink>
            )}
          </>
        )}

        {currentMenu.map((item, index) => {
          const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
          const href = item.getIn(['link', 'url'], '');
          const title = item.getIn(['link', 'title'], 'Untitled');
          const subTree = item.get('subtree');
          const description = item.getIn(['link', 'description'], '');

          return (
            <li
              key={`menu--main--menu-item-${title}:${href}`}
              className={c('menu--main--menu-item', `menu--main--menu-item--depth-${pathArray.length}`, {
                'menu--menu-item--active': item.getIn(['link', 'url']) === path,
                'menu--main--menu--hovered': hover === true,
                'menu--main--menu--inactive': hover === false,
              })}
              onMouseEnter={() => { setHover(true); }}
              onMouseLeave={() => { setHover(false); }}
            >
              <div
                className="NavigationMainMenuMobile__title"
              >
                {subTree && subTree.size === 0 ? (
                  <CoreLink
                    to={href}
                    target={attrs.get('target')}
                    onClick={() => { dispatch(hideNavMenu()); setHover(false); }}
                  >
                    {title}
                    <div
                      className="NavigationMainMenuMobile__items__arrow icon-after icon-arrow-right icon-variant-2"
                    />
                  </CoreLink>
                ) : (
                  <>
                    <div className="NavigationMainMenuMobile__title__inner" onClick={() => { addItemToPathArray(index); }}>
                      {title}
                      <div
                        className="NavigationMainMenuMobile__items__arrow icon-after icon-arrow-right"
                      />
                    </div>
                    {description && <div className="NavigationMainMenuMobile__title__description">{description}</div>}
                  </>

                )}
              </div>

            </li>
          );

        })}
      </div>
    </div>
  );
};

export default NavigationMainMenuMobile;
